import { Link } from 'react-router-dom';
import { blacklistItems } from '@/mocks/blacklist';
import SectionTitle from '@/components/feature/SectionTitle';

const eventIcons: Record<string, string> = {
  星轨联赛: 'ri-planet-line',
  极光杯: 'ri-trophy-line',
  暗夜争霸赛: 'ri-moon-line',
  雷霆竞技场: 'ri-flashlight-line',
  黎明锦标赛: 'ri-sun-line',
  深渊王者赛: 'ri-anchor-line',
};

export default function EventEntries() {
  const events = Array.from(new Set(blacklistItems.map((b) => b.event))).map((event) => {
    const items = blacklistItems.filter((b) => b.event === event);
    const lowest = items.reduce(
      (min, cur) => ((cur.performanceIndex || 100) < (min.performanceIndex || 100) ? cur : min),
      items[0],
    );
    return { event, items, lowest };
  });

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-8 py-12">
      <SectionTitle
        icon="ri-bar-chart-box-line"
        title="赛事黑榜快捷入口"
        subtitle="选择赛事，直达对应黑榜名单与实时排名报表"
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {events.map(({ event, items, lowest }) => (
          <Link
            key={event}
            to={`/category/blacklist?event=${encodeURIComponent(event)}`}
            className="group bg-background-50 border border-background-200 rounded-lg p-5 hover:border-primary-300 transition-colors cursor-pointer flex flex-col"
          >
            <div className="flex items-center justify-between mb-4">
              <span className="w-11 h-11 rounded-md bg-primary-600 text-background-50 flex items-center justify-center">
                <i className={`${eventIcons[event] || 'ri-trophy-line'} text-xl`}></i>
              </span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">
                共 {items.length} 条黑榜
              </span>
            </div>
            <h3 className="text-lg font-bold text-foreground-950 group-hover:text-primary-700 transition-colors">
              {event}
            </h3>
            <p className="mt-1.5 text-sm text-foreground-500">
              今日垫底选手：
              <span className="text-accent-700 font-semibold">{lowest.player}</span>
              <span className="ml-1 text-foreground-400">（指数 {lowest.performanceIndex}）</span>
            </p>
            <span className="mt-4 text-sm font-medium text-primary-700 flex items-center gap-1">
              查看实时报表
              <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}